<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <defs>
      <filter id="threat-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow
          dx="0"
          dy="2"
          stdDeviation="6"
          flood-color="#a78bfa"
          flood-opacity="0.5"
        />
      </filter>
    </defs>

    <!-- Outer orbit ring -->
    <circle
      cx="100"
      cy="75"
      r="50"
      fill="none"
      stroke="#c4b5fd"
      stroke-width="1"
      stroke-dasharray="3,6"
      class="pulse-ring"
    />

    <!-- Inner orbit ring -->
    <circle
      cx="100"
      cy="75"
      r="36"
      fill="none"
      stroke="#ddd6fe"
      stroke-width="1"
    />

    <g filter="url(#threat-glow)">
      <circle cx="100" cy="75" r="20" fill="#7c3aed" />
      <!-- Shield icon -->
      <path
        d="M100 65 L109 69 L109 78 C109 83 100 88 100 88 C100 88 91 83 91 78 L91 69 Z"
        fill="white"
        fill-opacity="0.25"
        stroke="white"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <polyline
        points="96,76 99,79 105,72"
        fill="none"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>

    <g class="orbit">
      <circle cx="100" cy="25" r="5" fill="#a78bfa" />
    </g>
    <g class="orbit-reverse">
      <circle cx="136" cy="75" r="4" fill="#c4b5fd" />
    </g>
    <g class="orbit">
      <circle cx="64" cy="75" r="3" fill="#ddd6fe" />
    </g>
  </svg>
</template>

<style scoped>
@keyframes orbit {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse-ring {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
}

.orbit {
  animation: orbit 16s linear infinite;
  transform-origin: 100px 75px;
}

.orbit-reverse {
  animation: orbit 20s linear infinite reverse;
  transform-origin: 100px 75px;
}

.pulse-ring {
  animation: pulse-ring 6s ease-in-out infinite;
}
</style>
